import Col from '@loggi/ui/components/col';
import Image from '@loggi/ui/components/image';
import Text from '@loggi/ui/components/text';
import colors from '@loggi/ui/components/utils/colors';
import clipart from 'images/illustration-map-pin.png';
import PropTypes from 'prop-types';
import React from 'react';
import AdditionalReceivers from './additional-receivers/additional-receivers.component';
import DestinationDescription from './destination-description/destination-description.component';
import DestinationTypeClassification from './destination-type-classification/destination-type-classification.component';
import {
  FACILITATE_DELIVERY_SUBTITLE,
  FACILITATE_DELIVERY_TITLE
} from './facilitate-delivery.constants';
import styles from './facilitate-delivery.styles.scss';

export default function FacilitateDelivery({
  destinationType,
  onClickDestinationType,
  destinationDescription,
  onClickDestinationDescription,
  additionalReceivers,
  onClickAdditionalReceivers
}) {
  const renderHead = () => (
    <Col flexDirection="row" alignItems="start">
      <Image src={clipart} noBackgroundColor />
      <Col>
        <Text size="400" color={colors.type.SMOKE_900}>
          {FACILITATE_DELIVERY_TITLE}
        </Text>
        <Col flexGrow="1" gutter={{ top: 'half' }}>
          <Text size="300" color={colors.type.STORM_500}>
            {FACILITATE_DELIVERY_SUBTITLE}
          </Text>
        </Col>
      </Col>
    </Col>
  );

  return (
    <Col className={styles.facilitateDelivery}>
      {renderHead()}
      <Col gutter={{ top: 'onehalf' }}>
        <DestinationTypeClassification
          destinationTypeData={destinationType}
          onClick={onClickDestinationType}
        />
        <AdditionalReceivers
          receiversData={additionalReceivers}
          onClick={onClickAdditionalReceivers}
          hasDivider
        />
        <DestinationDescription
          descriptionData={destinationDescription}
          onClick={onClickDestinationDescription}
          hasDivider
        />
      </Col>
    </Col>
  );
}

FacilitateDelivery.displayName = 'FacilitateDelivery';
FacilitateDelivery.propTypes = {
  destinationType: PropTypes.string,
  onClickDestinationType: PropTypes.func.isRequired,
  destinationDescription: PropTypes.string,
  onClickDestinationDescription: PropTypes.func.isRequired,
  additionalReceivers: PropTypes.string,
  onClickAdditionalReceivers: PropTypes.func.isRequired
};

FacilitateDelivery.defaultProps = {
  destinationType: null,
  destinationDescription: null,
  additionalReceivers: null
};
